module.exports = __webpack_public_path__ + "img/qr-menu-preview-small.4e3f2a8d.jpg";